import React from "react";
import { Link } from "react-router-dom";

export const Ticker = ({ items }) => {
  if (!items || items.length === 0) {
    // Reserve the exact same border-y/py-3 wrapper height the real ticker
    // uses so headlines popping in later don't push the page down (CLS).
    return (
      <div
        className="border-y border-black/10 py-3"
        style={{ backgroundColor: "var(--ticker-bg, #002d75)" }}
        data-testid="headline-ticker-loading"
        aria-hidden="true"
      >
        <div className="mx-5 h-[18px] w-2/3 max-w-md animate-pulse rounded bg-white/10 sm:mx-8" />
      </div>
    );
  }
  const doubled = [...items, ...items];

  const baseClass =
    "inline-flex items-center gap-3 font-display text-sm font-semibold text-white/85 px-1 cursor-pointer transition-opacity hover:opacity-80 hover:underline underline-offset-4 decoration-white/40";

  return (
    <div
      className="border-y border-black/10 py-3"
      style={{ backgroundColor: "var(--ticker-bg, #002d75)" }}
      data-testid="headline-ticker"
    >
      <div className="relative overflow-hidden">
        <div className="ticker-track whitespace-nowrap">
          {doubled.map((h, i) => {
            const content = (
              <>
                <span
                  className="h-1.5 w-1.5 rounded-full"
                  style={{ backgroundColor: h.source_color }}
                />
                <span className="label-kicker text-[#6CABDD]">
                  {h.source_name}
                </span>
                <span className="text-white/85">{h.title}</span>
                <span className="text-white/30">·</span>
              </>
            );
            const key = `${h.id}-${i}`;
            const testid = `ticker-headline-${i}`;

            if (!h.link) {
              return (
                <span key={key} className={baseClass.replace(" cursor-pointer", "")}>
                  {content}
                </span>
              );
            }
            // Internal LAST posts: same-tab navigation via React Router
            if (h.internal) {
              return (
                <Link key={key} to={h.link} data-testid={testid} className={baseClass}>
                  {content}
                </Link>
              );
            }
            // External news source: open in new tab
            return (
              <a
                key={key}
                href={h.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testid}
                className={baseClass}
              >
                {content}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};
